import * as Yup from 'yup';

export const validationSchema = ({ t }) =>
  Yup.object().shape({
    firstName: Yup.string()
      .typeError(t('First Name is required'))
      .required(t('First Name is required')),
    lastName: Yup.string()
      .typeError(t('Last Name is required'))
      .required(t('Last Name is required')),
    phone: Yup.string()
      .phone(t('Phone Number is invalid'))
      .nullable(),

    email: Yup.string()
      .email(t('Email Address is invalid'))
      .nullable()
      .when('phone', {
        is: val => !val,
        then: Yup.string()
          .typeError(t('Email Address or Phone is required'))
          .required(t('Email Address or Phone is required'))
      })
  });

export default validationSchema;
